import { Checkbox } from '@carboncopyco/ui';
import { Field, type FieldProps } from 'formik';
import { FilterEmailsLabel } from './FilterEmailsLabel';

export const FilterEmailsField = () => {
  return (
    <Field
      type="checkbox"
      name="security.filterEmailDomains"
    >
      {({
        field: { checked, value, ...rest },
        form: { setFieldValue },
      }: FieldProps) => {
        return (
          <div className="flex items-center p-2 gap-1">
            <Checkbox
              {...rest}
              checked={checked}
              onChange={() => {
                setFieldValue('security.filterEmailDomains', !checked);
              }}
              label={<FilterEmailsLabel />}
            />
          </div>
        );
      }}
    </Field>
  );
};
